import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatErr } from "../../lib/api";

export default function DevSupport() {
  const [tix, setTix] = useState([]);
  const refresh = () => api.get("/support-tickets").then(r=>setTix(r.data));
  useEffect(()=>{ refresh(); }, []);
  const update = async (t, status) => {
    try { await api.put(`/support-tickets/${t.id}`, { status, developer_response: t._reply||"" }); toast.success("Updated"); refresh(); }
    catch (e) { toast.error(formatErr(e)); }
  };
  return (
    <div className="space-y-6">
      <div><div className="overline mb-2">Inbox</div><h1 className="font-display text-4xl text-white">Support Tickets</h1></div>
      <div className="space-y-4">
        {tix.map(t => (
          <div key={t.id} className="card-luxe p-6">
            <div className="flex justify-between items-start gap-4">
              <div>
                <div className="overline">{t.type}</div>
                <div className="font-display text-lg text-white mt-1">{t.subject}</div>
                <div className="text-xs text-white/40 mt-1">From {t.raised_by} · {new Date(t.created_at).toLocaleString()}{t.user_email_target && ` · Target: ${t.user_email_target}`}</div>
              </div>
              <span className={`text-[10px] uppercase tracking-luxe px-2 py-1 ${t.status==="resolved"? "bg-[#32D74B]/10 text-[#32D74B]":"bg-copper/10 text-copper"}`}>{t.status}</span>
            </div>
            <p className="text-sm text-white/70 mt-3">{t.details}</p>
            {t.developer_response && <div className="mt-3 text-xs bg-white/5 p-3"><span className="text-white/40">Reply: </span>{t.developer_response}</div>}
            {t.status !== "resolved" && (
              <div className="mt-4 flex gap-2 items-end">
                <textarea rows={1} placeholder="Reply note (optional)" className="input-box flex-1 text-sm" onChange={(e)=>{t._reply=e.target.value;}}/>
                <button onClick={()=>update(t, "in_progress")} className="btn-outline">In Progress</button>
                <button onClick={()=>update(t, "resolved")} className="btn-primary">Resolve</button>
              </div>
            )}
          </div>
        ))}
        {tix.length === 0 && <div className="card-luxe p-10 text-center text-white/50">No tickets yet</div>}
      </div>
    </div>
  );
}
